import yaml from 'js-yaml';

/**
 * Recursively resolve all $ref in a schema and track referenced schemas.
 */
const resolveRefs = (obj, schemas, referencedSchemas) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => resolveRefs(item, schemas, referencedSchemas));
  }
  if (obj && typeof obj === 'object') {
    if (obj.$ref) {
      const refName = obj.$ref.replace(/^#\/components\/schemas\//, '');
      const refSchema = schemas[refName];
      if (!refSchema) throw new Error(`Reference ${obj.$ref} not found`);
      referencedSchemas.add(refName); // flagué pour suppression
      return resolveRefs(refSchema, schemas, referencedSchemas);
    }

    const result = {};
    for (const key in obj) {
      if (key !== '$ref') {
        result[key] = resolveRefs(obj[key], schemas, referencedSchemas);
      }
    }
    return result;
  }
  return obj;
};

/**
 * Flatten components.schemas: resolve $ref and remove schemas only used as references.
 */
export const fileToJsonSchema = async (file) => {
  const text = await file.text();
  let parsed;

  if (file.name.endsWith('.yaml') || file.name.endsWith('.yml')) {
    parsed = yaml.load(text);
  } else {
    parsed = JSON.parse(text);
  }

  let schemas;
  if (parsed.components?.schemas) {
    // OpenAPI
    schemas = parsed.components.schemas;
  } else if (parsed.type === 'object' && parsed.properties) {
    // JSON Schema simple
    schemas = { [parsed.title || 'root']: parsed };
  } else {
    throw new Error(
      `Unsupported schema format in file "${file.name}". Expected OpenAPI with components.schemas or a JSON Schema with type=object.`
    );
  }

  const referencedSchemas = new Set();

  // First pass: resolve all refs inside schemas and track which schemas are referenced
  const flatSchemas = {};
  for (const [name, schema] of Object.entries(schemas)) {
    flatSchemas[name] = resolveRefs(schema, schemas, referencedSchemas);
  }

  // suprime les noeuds tagués
  for (const refName of referencedSchemas) {
    delete flatSchemas[refName];
  }

  return {
    type: 'object',
    title: parsed.info?.title || 'API Schema',
    description: parsed.info?.description || '',
    properties: flatSchemas
  };
};
